import { z } from 'zod';

export const BatteryRemainingSchema = z.object({
    remaining: z.number(),
    // Опционально: id используется только как React-key в списке банок.
    // На дронах с одной батареей сервер иногда не присылает id вовсе — раньше
    // это заваливало валидацию ВСЕЙ батареи (id: z.int() падал на undefined),
    // и .catch([]) в DroneHub тихо превращал её в пустой список без заряда.
    id: z.int().optional(),
    voltage: z.number()
});

export type BatteryRemainingData = z.infer<typeof BatteryRemainingSchema>;

export const BatteryRemainingListSchema = z.array(BatteryRemainingSchema);

export type BatteryRemainingListData = z.infer<typeof BatteryRemainingListSchema>;
